










































import AbpBase from "../../../lib/abpbase";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {
	GetMachineChangJList,
	InsertMachineChangJ,
	UpdateMachineChangJById,
	DeleteMachineChangJ
} from '../../../api/specialDictionary'
import {GetListByCode} from "@/api/configureDictionary"
import repair from './parts/repair'

@Component({
	components: {repair}
})
export default class Water extends AbpBase {
	cancel(){
		this.dialogFormVisible = false
	}
	visibleChange(value: boolean) {
		if (!value) {
			this.dialogFormVisible = false;
			(this.$refs.form as any).resetFields()
			this.getData()
		}
	}
	columns = [
		{
			key: 'changJ',
			title: '厂家名称'
		},
		{
			key: 'status',
			title: '是否启用',
			render:(h:any, p:any)=>{
				return h('span', p.row.status ? '启用' : '禁用')
			}
		},
		{
			key: 'spare',
			title: '备注'
		},
		{
			key: '',
			width: 280,
			title: '操作',
			render:(h:any, p:any)=>{
				return h('div', [
					h('Button',{
						props:{type: 'primary'},
						style:{marginRight:'20px'},
						on:{
							click:()=>{
								this.repair(p.row)
							}
						}
					},'型号'),
					h('Button',{
						props:{type: 'primary'},
						style:{marginRight:'20px'},
						on:{
							click:()=>{
								this.edit(p.row)
							}
						}
					},'编辑'),
					h('Button',{
						props:{type: 'error'},
						on:{
							click:()=>{
								this.del(p.row)
							}
						}
					},'删除'),
				])
			}
		},
	]
	key = '' //查询条件
	page = 1 //当前页
	dialogTitle = ''
	dialogForm: any = {}
	dialogFormVisible = false
	dialogFormLabelWidth = '120px'
	tableTotalSize = 0
	tableData = []
	tableLoading = false
	repireShow = false
	maintenanceShow = false
	checkShow = false

	changJs = []  //厂家下拉
	created() {
		this.getData()
		this.getSelects()
	}

	//维修
	repair(row: any) {
		this.dialogForm = Object.assign({}, row)
		this.repireShow = true
	}

	//保养
	maintenance(row: any) {
		this.dialogForm = Object.assign({}, row)
		this.maintenanceShow = true
	}

	//检查
	check(row: any) {
		this.dialogForm = Object.assign({}, row)
		this.checkShow = true
	}

	createCounty() {
		this.dialogTitle = '新增厂家'
		this.dialogForm = {status: true, countryWB: '', countryPY: ''}
		this.dialogFormVisible = true
	}

	private async getData() {
		this.tableLoading = true
		let res = await GetMachineChangJList({
			QueryString: this.key,
			SkipCount: this.page,
			MaxResultCount: 10
		})
		this.tableData = res.items
		this.tableTotalSize = res.totalCount
		this.tableLoading = false
	}

	handleClose() {
		this.dialogFormVisible = false
	}

	edit(row: any) {
		this.dialogTitle = '编辑厂家'
		this.dialogForm = JSON.parse(JSON.stringify(row))
		this.dialogFormVisible = true
	}

	async del(row: any) {
		this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeleteMachineChangJ({Id: row.id})
			this.getData()
		}).catch(() => {

		});
	}

	async confirm() {
		(this.$refs.form as any).validate(async (valid:boolean)=>{
			if(valid){
				if (this.dialogTitle === '新增厂家') {
					let res = await InsertMachineChangJ(this.dialogForm)
				} else if (this.dialogTitle === '编辑厂家') {
					let res = await UpdateMachineChangJById(this.dialogForm)
				}
				this.dialogFormVisible = false
				this.getData()
			}
		})

	}

	rules = {
		changJ: [{required: true, message: '请输入内容', trigger: 'blur'}],
		// machineModel: [{required: true, message: '请输入内容', trigger: 'blur'}],
		// countryWB:[{required: true, message: '请输入内容', trigger: 'blur'}],
	}

	pageChange(val: any) {
		this.page = val
		this.getData()
	}

	private async getSelects() {
		let res1 = await GetListByCode({input: "013"})  //生产厂家下拉
		this.changJs = res1
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/specialDictionary/factory/index.vue